import React from 'react'
import {useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

const MyStokkeSeo = ({subPageTitle}) => {
    const {formatMessage} = useIntl()

    const myStokkeTitle = formatMessage({
        id: 'global.my_account',
        defaultMessage: 'My Stokke'
    })

    const pageTitle = subPageTitle ? `${subPageTitle} | ${myStokkeTitle}` : myStokkeTitle

    const pageTitleString = formatMessage(
        {
            id: 'global.page.title',
            defaultMessage: '{pageTitle} | Stokke® Online Shop'
        },
        {
            pageTitle
        }
    )

    return (
        <Helmet>
            <title>{pageTitleString}</title>
        </Helmet>
    )
}

MyStokkeSeo.propTypes = {
    subPageTitle: PropTypes.string
}

export default MyStokkeSeo
